import React from 'react';
import './AddIntegration.css'

function AddIntegration () {
   
        return (
            <div>
                <div className="integrationConfigPage">
  <div className="integrationConfigContainer">
    
    {/* <!-- Header --> */}
    <div className="integrationHeaderWrapper">
      <h2 className="integrationTitle">Thêm cấu hình tích hợp</h2>

      <div className="integrationBreadcrumbWrapper">
        <span className="integration-breadcrum-item">Trang chủ</span>
        <span className="integration-breadcrumb-slash">/</span>

        <span className="integration-breadcrum-item">Tích hợp hệ thống</span>
        <span className="integration-breadcrumb-slash">/</span>

        <span className="integration-bread-crumb-active">
          Thêm cấu hình tích hợp
        </span>
      </div>
    </div>

    {/* <!-- Thông tin chung --> */}
    <div className="integrationSectionWrapper">
      <h3 className="inte-gration-section-title">Thông tin chung</h3>

      <div className="row">
        {/* <!-- Tên hệ thống --> */}
        <div className="col-sm-6">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">
              Tên hệ thống <span>*</span>
            </label>

            <input
              type="text"
              className="integrationInput"
              placeholder="Nhập tên hệ thống tích hợp..."
            />
          </div>
        </div>

        {/* <!-- Mã hệ thống --> */}
        <div className="col-sm-6">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">
              Mã hệ thống <span>*</span>
            </label>

            <input
              type="text"
              className="integrationInput"
              placeholder="Nhập mã hệ thống (không dấu, viết liền)..."
            />
          </div>
        </div>

        {/* <!-- Mô tả --> */}
        <div className="col-sm-6">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">Mô tả</label>

            <textarea
              className="integrationTextarea"
              placeholder="Nhập mô tả về hệ thống tích hợp..."
            ></textarea>

            <span className="inte-gration-text-count">0/255</span>
          </div>
        </div>

        {/* <!-- Loại tích hợp --> */}
        <div className="col-sm-6">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">
              Loại tích hợp <span>*</span>
            </label>

            <div className="integrationRadioGroup">
              <label className="inte-gration-radio-item">
                <input
                  type="radio"
                  name="integrationType"
                  checked
                />
                REST API
              </label>

              <label className="inte-gration-radio-item">
                <input
                  type="radio"
                  name="integrationType"
                />
                SOAP WebService
              </label>

              <label className="inte-gration-radio-item">
                <input
                  type="radio"
                  name="integrationType"
                />
                CSDL trực tiếp
              </label>

              <label className="inte-gration-radio-item">
                <input
                  type="radio"
                  name="integrationType"
                />
                Khác
              </label>
            </div>
          </div>
        </div>

        {/* <!-- Giao thức --> */}
        <div className="col-sm-6">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">
              Giao thức <span>*</span>
            </label>

            <div className="integrationSelectWrapper">
              <select className="integrationSelect">
                <option>HTTPS</option>
              </select>
            </div>
          </div>
        </div>

        {/* <!-- Phiên bản API --> */}
        <div className="col-sm-6">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">Phiên bản API</label>

            <input
              type="text"
              className="integrationInput"
              placeholder="Nhập phiên bản API (nếu có)..."
            />
          </div>
        </div>
      </div>
    </div>

    {/* <!-- Thông tin kết nối --> */}
    <div className="integrationSectionWrapper">
      <h3 className="inte-gration-section-title">Thông tin kết nối</h3>

      <div className="row">
        {/* <!-- Endpoint --> */}
        <div className="col-sm-4">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">
              Endpoint (URL) <span>*</span>
            </label>

            <input
              type="text"
              className="integrationInput"
              placeholder="https://api.example.com/v1/..."
            />
          </div>
        </div>

        {/* <!-- Phương thức xác thực --> */}
        <div className="col-sm-4">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">
              Phương thức xác thực <span>*</span>
            </label>

            <div className="integrationSelectWrapper">
              <select className="integrationSelect">
                <option>API Key</option>
              </select>
            </div>
          </div>
        </div>

        {/* <!-- Timeout --> */}
        <div className="col-sm-4">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">
              Timeout (giây) <span>*</span>
            </label>

            <input
              type="text"
              className="integrationInput"
              value="30"
            />

            <span className="inte-gration-hint-text">
              Thời gian chờ kết nối tối đa
            </span>
          </div>
        </div>

        {/* <!-- API KEY --> */}
        <div className="col-sm-4">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">API Key</label>

            <div className="integrationPasswordWrapper">
              <input
                type="text"
                className="integrationInput"
                placeholder="Nhập API Key..."
              />

              <span className="integrationEyeIcon">
                <i className="fa-regular fa-eye"></i>
              </span>
            </div>
          </div>
        </div>

        {/* <!-- Secret Key --> */}
        <div className="col-sm-4">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">Secret Key</label>

            <div className="integrationPasswordWrapper">
              <input
                type="password"
                className="integrationInput"
                placeholder="Nhập Secret Key..."
              />

              <span className="integrationEyeIcon">
                <i className="fa-regular fa-eye"></i>
              </span>
            </div>
          </div>
        </div>

        {/* <!-- Header --> */}
        <div className="col-sm-4">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">Header bổ sung</label>

            <button className="integrationAddHeaderButton">
              <i className="fa-solid fa-plus"></i>
              Thêm header
            </button>

            <span className="inte-gration-hint-text">
              Thêm các header nếu hệ thống yêu cầu
            </span>
          </div>
        </div>
      </div>
    </div>

    {/* <!-- Cấu hình nâng cao --> */}
    <div className="integrationSectionWrapper">
      <h3 className="inte-gration-section-title">
        Cấu hình nâng cao
      </h3>

      <div className="row">
        {/* <!-- Content type --> */}
        <div className="col-sm-4">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">
              Content-Type <span>*</span>
            </label>

            <div className="integrationSelectWrapper">
              <select className="integrationSelect">
                <option>application/json</option>
              </select>
            </div>
          </div>
        </div>

        {/* <!-- Kiểu dữ liệu --> */}
        <div className="col-sm-4">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">
              Kiểu dữ liệu
            </label>

            <div className="integrationSelectWrapper">
              <select className="integrationSelect">
                <option>JSON</option>
              </select>
            </div>
          </div>
        </div>

        {/* <!-- Mã hóa --> */}
        <div className="col-sm-4">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">
              Mã hóa dữ liệu
            </label>

            <div className="integrationSelectWrapper">
              <select className="integrationSelect">
                <option>Không mã hóa</option>
              </select>
            </div>
          </div>
        </div>

        {/* <!-- SSL --> */}
        <div className="col-sm-4">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">
              Chứng chỉ SSL
            </label>

            <div className="integrationUploadWrapper">
              <button className="integrationUploadButton">
                Chọn tệp tin
              </button>

              <span className="inte-gration-upload-text">
                Không có tệp nào được chọn
              </span>
            </div>

            <span className="inte-gration-hint-text">
              Tải lên file chứng chỉ SSL (nếu hệ thống sử dụng chứng chỉ tự ký)
            </span>
          </div>
        </div>

        {/* <!-- Ghi chú --> */}
        <div className="col-sm-8">
          <div className="integrationFieldWrapper">
            <label className="inte-gration-label-share">Ghi chú</label>

            <textarea
              className="integrationTextarea"
              placeholder="Nhập ghi chú (nếu có)..."
            ></textarea>

            <span className="inte-gration-text-count-below">0/255</span>
          </div>
        </div>
      </div>
    </div>

    {/* <!-- Kiểm tra kết nối --> */}
    <div className="integrationSectionWrapper">
            <div className='check-conncected'>
               <div className='check-conncected'>
                 <div>
                    <h3 className="inte-gration-section-title">
        Kiểm tra kết nối
      </h3>
        <h4 className="inte-gration-description">
        Sau khi lưu cấu hình, bạn có thể kiểm tra kết nối để đảm bảo hệ thống hoạt động chính xác.
      </h4>
                 </div>
      

  
               </div>
      <div className='check-conncected'>
           <button className=" integrationTestButton">
          <i className="fa-solid fa-wifi"></i>
          Kiểm tra kết nối
        </button>
      </div>
            </div>

      <div className="inte-gration-bottom-wrapper">
     

        <div className="inte-gration-action-wrapper">
          <button className="integration-cancel-button">
            <i className="fa-solid fa-xmark"></i>
            Hủy bỏ
          </button>

          <button className="inte-gration-save-button">
            <i className="fa-regular fa-floppy-disk"></i>
            Lưu cấu hình
          </button>
        </div>
      </div>
    </div>

  </div>
</div>
            </div>
        );
    
}


export default AddIntegration;